import {
    ArticlePreviewResponse,
    Collection,
    UserResponse,
    ContentWithSharesResponse,
    ProfileUserResponse,
    PublicUserResponse
} from "@authory-packages/core";
import { V3SidebarPanelSpacer } from "../ReusableStyledComponents/SidebarSpacer";
import { V3ConfirmationModal } from "../V3ConfirmationModal";
import { V3EmbedModal, EmbedTarget } from "../V3EmbedModal";
import { V3ModalIconSegmentVariant } from "../ReusableStyledComponents/ModalIconSegment";

interface V3EmbedPanelElementProps {
    embedModalOpen: boolean;
    setEmbedModalOpen: (open: boolean) => void;
    content?: ContentWithSharesResponse;
    author: UserResponse | ProfileUserResponse | PublicUserResponse;
    target: EmbedTarget;
    collection?: Collection;
    items?: ArticlePreviewResponse[];
    onConfimationCallback?: () => void;
    confirmationTitle?: string;
    confirmationDesc?: string;
    canOpenEmbedPanel: boolean;
    confirmationCTALabel?: string;
}

export const V3EmbedPanelElement = ({
    content,
    author,
    target,
    collection,
    items,
    onConfimationCallback,
    embedModalOpen,
    setEmbedModalOpen,
    confirmationTitle = "",
    confirmationDesc = "",
    canOpenEmbedPanel,
    confirmationCTALabel = "Publish portfolio"
}: V3EmbedPanelElementProps) => {
    return (
        <>
            <V3SidebarPanelSpacer>
                {embedModalOpen && (
                    <>
                        {canOpenEmbedPanel ? (
                            <>
                                <V3EmbedModal
                                    modalOpen={embedModalOpen}
                                    onCloseHandler={() => setEmbedModalOpen(false)}
                                    target={target}
                                    author={author}
                                    collection={collection}
                                    item={content?.article}
                                    items={items}
                                />
                            </>
                        ) : (
                            <>
                                <V3ConfirmationModal
                                    onSubmit={() => {
                                        onConfimationCallback && onConfimationCallback();
                                        setEmbedModalOpen(true);
                                    }}
                                    setModalOpen={setEmbedModalOpen}
                                    modalOpen
                                    title={confirmationTitle}
                                    btnLabel={confirmationCTALabel}
                                    useIcon
                                    variant={V3ModalIconSegmentVariant.warning}
                                    description={confirmationDesc}
                                />
                            </>
                        )}
                    </>
                )}
            </V3SidebarPanelSpacer>
        </>
    );
};
